<app-label-input [hasTooltip]="hasTooltip()" [required]="required()" [textTooltip]="textTooltip()"
   [textLabel]="textLabel()" />
@if(disabled()) {
<div class="d-flex align-items-start gap-10">
   <mat-form-field class="w-100" appearance="outline">
      <input matInput [type]="type()" [value]="value() ? value() : ''" disabled />
   </mat-form-field>
</div>
} @else {
<div class="d-flex align-items-start gap-10">
   <mat-form-field class="w-100" appearance="outline">
      <input matInput [formControlName]="nameControl()!" placeholder="" [maxlength]="maxlength()"
         (blur)="onChangeBlur()" autocomplete="off" />
   </mat-form-field>
</div>
}